import Welcome from "./welcome"
import SingleChoice from "./singleChoice"
import MultiChoice from "./multiChoice"
import Selfie from "./selfie"
import Input from "./input"
import Email from "./email"
import Thankyou from "./thankYou"
import getInputTagValues from "../../../../utils/responseData"
import { useEffect } from "react"

type QuestionProps = {
	question: {
		type: string;
		_id: string;
		imgUrl: string;
		questionText: string;
		answers: {
			_id: string;
			answerText: string;
			answerImgUrl: string;
			linkedQuestionId: string;
			inputType: string;
			label: string;
			tags: string[];
			required: boolean;
		}[];
		cta: {
			_id: string;
			ctaType: string;
			linkedQuestionId: string;
			ctaText: string;
		}[];
	};
	handleBackBtn: () => void;
	userResponse: Array<{
		questionType: string
		_id: string;
		answerResponse: Array<{ _id: string }>;
		selfieResponse: Array<{ beta: { skinconditions: object } }>;
	}>; // Specify the type argument for the Array type
	updateUserResponse: (response: {
		questionType: string;
		nextQuestionId: string;
		_id: string;
		action?: string;
		answerResponse: Array<object>;
		selfieResponse: Array<object>;
		selfieID: string;
		userSelfie: string;
	}) => void;
	aiConfig: object;
	aiType: object;
	backBtnConfig: object;
	sessionID: string;
	saveAppEvent: () => void;
	questionIndex: string;
	quiz: object;
	params: object;
	disableAutoScroll: boolean;
}

function Question({ question, handleBackBtn, userResponse, updateUserResponse, aiConfig, aiType, backBtnConfig, sessionID, saveAppEvent, questionIndex, quiz, params, disableAutoScroll }: QuestionProps) {

	const getResponseData = () => {
		return userResponse.find((response: { _id: string }) => response._id === question._id)
	}

	const getSelfieResponse = () => {
		for (const response of userResponse) {
			if (response.questionType === "selfie") {
				return response?.selfieResponse[0]?.beta;
			}
		}
	}

	useEffect(() => {
		// document.getElementById("tangent-main-container").scrollIntoView({
		// 	behavior: "smooth"
		// }); 
		if (userResponse.length === 0 || disableAutoScroll) return;
		const element = document.getElementById('tangent-main-container');
		const offset = Number(element?.dataset.offset) || 0; // Adjust the offset as needed
		const elementPosition = element.getBoundingClientRect().top + window.scrollY;
		window.scrollTo({
			top: elementPosition - offset,
			behavior: 'smooth',
		});
	}, [userResponse, disableAutoScroll])

	const SelectQuestion = () => {
		switch (question.type) {
			case "welcome":
				return <Welcome question={question}
					updateUserResponse={updateUserResponse} />
			case "selfie":
				return <Selfie
					question={question}
					handleBackBtn={handleBackBtn}
					updateUserResponse={updateUserResponse}
					responseData={getResponseData()}
					saveAppEvent={saveAppEvent}
					questionIndex={questionIndex}
					backBtnConfig={backBtnConfig} />
			case "single":
				return <SingleChoice
					question={question}
					handleBackBtn={handleBackBtn}
					updateUserResponse={updateUserResponse}
					responseData={getResponseData()}
					selfieResponse={getSelfieResponse()}
					aiConfig={aiConfig}
					aiType={aiType}
					backBtnConfig={backBtnConfig}
					inputs={getInputTagValues(userResponse, quiz)} />
			case "multi":
				return <MultiChoice
					question={question}
					handleBackBtn={handleBackBtn}
					updateUserResponse={updateUserResponse}
					responseData={getResponseData()}
					selfieResponse={getSelfieResponse()}
					aiConfig={aiConfig}
					aiType={aiType}
					backBtnConfig={backBtnConfig}
					inputs={getInputTagValues(userResponse, quiz)} />
			case "input":
				return <Input question={question}
					handleBackBtn={handleBackBtn}
					updateUserResponse={updateUserResponse}
					responseData={getResponseData()}
					backBtnConfig={backBtnConfig}
					inputs={getInputTagValues(userResponse, quiz)} />
			case "email":
				return <Email question={question}
					handleBackBtn={handleBackBtn}
					updateUserResponse={updateUserResponse}
					backBtnConfig={backBtnConfig}
					inputs={getInputTagValues(userResponse, quiz)} />
			case "thanks":
				return <Thankyou question={question}
					userResponse={userResponse}
					inputs={getInputTagValues(userResponse, quiz)}
					sessionID={sessionID}
					quiz={quiz}
					params={params} />
		}
	}

	return (
		<SelectQuestion />
	)
}

export default Question
